/** @param {string} string */
export function downcaseFirst(string) {
  return `${string[0].toLowerCase()}${string.slice(1)}`;
}

/** @param {string} string */
export function upcaseFirst(string) {
  return `${string[0].toUpperCase()}${string.slice(1)}`;
}

/** @param {string} string */
export function kebabToCamelCase(string) {
  const [first, ...rest] = string.split("-");
  return first + rest.map((part) => upcaseFirst(part)).join("");
}
